import { render, staticRenderFns } from "./plan-pin-guard.vue?vue&type=template&id=3faa4547"
import script from "./plan-pin-guard.js?vue&type=script&lang=js&external"
export * from "./plan-pin-guard.js?vue&type=script&lang=js&external"
import style0 from "./plan-pin-guard.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports